export interface ParsedToken {
  exp: number;
  iat: number;
  iss?: string;
  user?: {
    identity: string;
    organization: string;
    role: string;
    policies: string[];
    is_vlab?: boolean;
  };
}

export function parseJwt(token: string): ParsedToken | null {
  try {
    const parts = token.split('.');
    if (parts.length !== 3) return null;

    const base64 = parts[1].replace(/-/g, '+').replace(/_/g, '/');
    const padded = base64 + '='.repeat((4 - (base64.length % 4)) % 4);
    const bytes = Uint8Array.from(atob(padded), (c) => c.charCodeAt(0));
    const payload = JSON.parse(new TextDecoder().decode(bytes));

    if (typeof payload?.exp !== 'number' || typeof payload?.iat !== 'number') {
      return null;
    }

    return payload as ParsedToken;
  } catch {
    return null;
  }
}
